import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import { Form, Button, Col, Row, Spin, Input, Select } from "antd";
import axios from '../../utils/request';

export class XdfEditApplicant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            applicantModel: { tenantId: 0, jobId: "", personId: "", userId: 0, applyId: ""},
            applicantInfo: { JobCode: "", JobTitle: "", CadidateId: "", Name: "", Mobile: "", Gender: "", EducationLevel: "", Email: "", IsExcellentEducation: "" },
            genderSelectData: [{ id: 0, name: "男" }, { id: 1, name: "女" }],
            isExcellentEducationSelectData: [{ id: "True", name: "是" }, { id: "False", name: "否" }],
            educationLevelSelectData: [
                { id: 1, name: "本科" }, { id: 2, name: "硕士研究生" }, { id: 3, name: "高中" },
                { id: 4, name: "中技（中专/技校/职高）" }, { id: 5, name: "大专" }, { id: 6, name: "MBA" },
                { id: 7, name: "博士研究生" }, { id: 8, name: "初中" }, { id: 9, name: "小学" }, { id: 10, name: "保密" }]
        }
    };
    componentDidMount() {
        document.title = '补充/编辑简历信息'
        const urlParams = new URLSearchParams(window.location.search);
        const personId = urlParams.get("personId");
        const jobId = urlParams.get("jobId");
        const applyId = urlParams.get("applyId");
        const tenantId = parseInt(urlParams.get("tenantId"));
        const userId = parseInt(urlParams.get("userId"));
        if (!personId || !jobId || !tenantId) {
            window.location.href = "/no_permission";
        }
        this.loadPage(tenantId, personId, jobId, userId, applyId);
        //let errorMessage = "";
        //if (jobId !== "310167149") {
        //    errorMessage = "此功能暂未开放！"
        //    this.setState({ errorMessage, isLoading: false, isReady: true });
        //} else {
        //    this.loadPage(tenantId, personId, jobId, userId);
        //}
    };

    loadPage = (tenantId, personId, jobId, userId, applyId) => {
        let applicantModel = this.state.applicantModel;
        applicantModel.tenantId = tenantId;
        applicantModel.jobId = jobId;
        applicantModel.personId = personId;
        applicantModel.userId = userId;
        applicantModel.applyId = applyId;
        this.setState({ applicantModel: applicantModel })
        const bodyString = JSON.stringify(applicantModel);

        this.GetApplicantInfo(bodyString);
    };

    GetApplicantInfo = (bodyString) => {
        debugger;
        axios.post("/api/xdf/GetApplicantInfoForUpdate",
            bodyString,
            {
                headers: { "Content-Type": "application/json" }
            })
            .then(res => {
                const isSuccess = res.data.isSuccess;
                if (isSuccess) {
                    const data = res.data.data;
                    let applicantInfo = {};
                    applicantInfo.JobCode = data.jobCode;
                    applicantInfo.JobTitle = data.jobTitle;
                    applicantInfo.CadidateId = data.cadidateId;
                    applicantInfo.Name = data.name;
                    applicantInfo.Mobile = data.mobile;
                    applicantInfo.Gender = data.gender;
                    applicantInfo.EducationLevel = data.educationLevel;
                    applicantInfo.Email = data.email;
                    applicantInfo.IsExcellentEducation = data.isExcellentEducation;
                    this.setState({ isLoading: false, isReady: true, applicantInfo: applicantInfo });
                }
            })
            .catch(error => {
                debugger
                console.log("GetApplicantInfo api error", error);
                window.location.href = "/no_permission";
            })
            .finally();
    };

    onFinish = (values) => {
        values.tenantId = this.state.applicantModel.tenantId;
        values.personId = this.state.applicantModel.personId;
        values.userId = this.state.applicantModel.userId;
        const bodyString = JSON.stringify(values);
        this.UpdateApplicantProfile(bodyString);
    };

    UpdateApplicantProfile = (bodyString) => {
        axios.post("/api/xdf/UpdateApplicantProfile",
            bodyString,
            {
                headers: { "Content-Type": "application/json" }
            })
            .then(res => {
                const statuscode = res.status;
                let errorMessage = "";
                if (statuscode !== 200) {
                    errorMessage = "更新应聘者信息失败，请联系管理员！"
                    this.setState({ errorMessage, isLoading: false, isReady: true });
                }
                else {
                    //errorMessage = "更新应聘者信息成功！"
                    //this.setState({ errorMessage, isLoading: false, isReady: true });
                    window.location.href = "/xdf-offer/index?tenantId=" + this.state.applicantModel.tenantId + "&personId=" + this.state.applicantModel.personId + "&jobId=" + this.state.applicantModel.jobId + "&userId=" + this.state.applicantModel.userId + "&applyId=" + this.state.applicantModel.applyId;
                }
            })
            .catch(error => {
                debugger
                console.log("UpdateApplicantProfile api error", error);
                window.location.href = "/no_permission";
            })
            .finally();
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px", fontSize: "22px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            } else {
                return (
                    <Spin size="large" spinning={this.state.isLoading}>
                        <div style={{ margin: "32px auto", maxWidth: "600px" }}>
                            <Form style={{ "paddingLeft": "0px", "paddingRight": "70px" }} onFinish={this.onFinish} labelCol={{ "span": 7 }} wrapperCol={{ "span": 19 }} initialValues={this.state.applicantInfo}>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="职位编码" name="JobCode"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "职位编码不能为空！"
                                                }
                                            ]}>
                                            <Input readOnly={true} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="职位名称" name="JobTitle"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "职位名称不能为空！"
                                                }
                                            ]}>
                                            <Input readOnly={true} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="应聘者ID" name="CadidateId"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "应聘者ID不能为空！"
                                                }
                                            ]}>
                                            <Input readOnly={true} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="应聘者姓名" name="Name"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "应聘者姓名不能为空！"
                                                }
                                            ]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="手机号码" name="Mobile"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "手机号码不能为空！"
                                                }
                                            ]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="性别" name="Gender"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "性别不能为空！"
                                                }
                                            ]}>
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                style={{ width: '100%' }}
                                                placeholder="请选择性别">
                                                {this.state.genderSelectData.map(el => (
                                                    <Select.Option key={el.id}>{el.name}</Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="个人邮箱" name="Email"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "个人邮箱不能为空！"
                                                }
                                            ]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 5, offset: 20 }} md={{ span: 5, offset: 20 }} lg={{ span: 5, offset: 20 }}>
                                        <Form.Item>
                                            <Button type="primary" className="float-right" block htmlType="submit" title="保存成功会跳回推送页面">保存</Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Spin>
                );
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}